<app-main-layout [clickBack]="onClickBack" [disableWatchingRoutes]="true">
  <div class="main-heading">
    <h2>Financing Plans</h2>
  </div>
  <ul class="financing-plans">
    @for (item of plans; track item) {
      <li>
        <strong class="title">{{item.title}}</strong>
        <div class="cs-inner-html-18" [innerHtml]="item.text"></div>
        <dl class="info">
          @for (infoItem of item.description_list; track infoItem) {
            <dt>{{infoItem.name}}</dt>
            <dd>
              @if (infoItem.unique_name === 'loan_period') {
                <span class="period-item-holder">
                  @for (_ of [].constructor(+infoItem.value); track _) {
                    <i class="period-item"></i>
                  }
                </span>
              }
              @if (infoItem.unique_name !== 'loan_period') {
                <span>{{infoItem.value}}</span>
              }
            </dd>
          }
        </dl>
      </li>
    }
  </ul>
</app-main-layout>